import Button from '@components/Button'

type ExplanationButtonProps = {
  onClick: () => void
}

const ExplanationButton: React.FC<ExplanationButtonProps> = ({ onClick }) => {
  return (
    <Button.primary className={'w-[188px]'} onClick={onClick}>
      {'문제 해설보기'}
    </Button.primary>
  )
}

export default ExplanationButton
